export class DateHelper {
    public static DATE_FORMAT_DISPLAY_SELECT = 'dd/mm/yy';
    public static DATE_FORMAT = 'DD/MM/YYYY';
    public static DATE_FORMAT_HTML = 'dd/MM/yyyy';
    public static DATE_TIME_FORMAT = 'dd/MM/yyyy hh:mm';

    public static getStartOfDate(date: Date = new Date()) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    // #region yyyy-mm-dd <-> date
    /**
     * Formats a date in yyyy-mm-dd format without timezone conversion
     * @param date The date to format
     * @returns Date string in yyyy-mm-dd format
     */
    public static formatDateLocal(date: Date): string {
        const offsetDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        return offsetDate.toISOString().split('T')[0];
    }

    /**
     * Parses a yyyy-mm-dd string to a Date object in local timezone without UTC conversion
     * @param dateString The date string in yyyy-mm-dd format
     * @returns Date object in local timezone, or null if dateString is null/undefined/invalid
     */
    public static parseDateLocal(dateString: string | null | undefined): Date | null {
        if (!dateString) return null;

        const parts = dateString.split('-');
        if (parts.length !== 3) return null;

        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
        const day = parseInt(parts[2], 10);

        if (isNaN(year) || isNaN(month) || isNaN(day)) return null;

        return new Date(year, month, day);
    }

    // #endregion

}